import { render, staticRenderFns } from "./ArchivePayments.vue?vue&type=template&id=6be5af3e&"
import script from "./ArchivePayments.vue?vue&type=script&lang=js&"
export * from "./ArchivePayments.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchivePayments.vue"
export default component.exports